module.exports = __webpack_public_path__ + "50afcb1fb84d74d76c8e4cd75e23a544.png";